// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/delivery.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CalculateRatesRequest, CalculateRatesResponse, CancelShipmentRequest, ConfigureDeliveryMethodRequest, CreateDeliveryRateRequest, CreateDeliveryZoneRequest, CreateShipmentRequest, DeleteDeliveryMethodRequest, DeleteDeliveryRateRequest, DeleteDeliveryZoneRequest, DeliveryMethodConfig, DeliveryRate, DeliveryZone, GetShipmentRequest, ListDeliveryMethodsRequest, ListDeliveryMethodsResponse, ListDeliveryRatesRequest, ListDeliveryRatesResponse, ListDeliveryZonesRequest, ListDeliveryZonesResponse, ListShipmentsRequest, ListShipmentsResponse, Shipment, TrackShipmentRequest, UpdateDeliveryMethodRequest, UpdateDeliveryRateRequest, UpdateDeliveryZoneRequest } from "./delivery_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.DeliveryService
 */
export const DeliveryService = {
  typeName: "omnios.v1.DeliveryService",
  methods: {
    /**
     * Delivery method configuration
     *
     * @generated from rpc omnios.v1.DeliveryService.ConfigureDeliveryMethod
     */
    configureDeliveryMethod: {
      name: "ConfigureDeliveryMethod",
      I: ConfigureDeliveryMethodRequest,
      O: DeliveryMethodConfig,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DeliveryService.UpdateDeliveryMethod
     */
    updateDeliveryMethod: {
      name: "UpdateDeliveryMethod",
      I: UpdateDeliveryMethodRequest,
      O: DeliveryMethodConfig,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DeliveryService.DeleteDeliveryMethod
     */
    deleteDeliveryMethod: {
      name: "DeleteDeliveryMethod",
      I: DeleteDeliveryMethodRequest,
      O: DeliveryMethodConfig,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DeliveryService.ListDeliveryMethods
     */
    listDeliveryMethods: {
      name: "ListDeliveryMethods",
      I: ListDeliveryMethodsRequest,
      O: ListDeliveryMethodsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Rate calculation (via WASM plugins or built-in)
     *
     * @generated from rpc omnios.v1.DeliveryService.CalculateRates
     */
    calculateRates: {
      name: "CalculateRates",
      I: CalculateRatesRequest,
      O: CalculateRatesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Shipment operations (via WASM plugins)
     *
     * @generated from rpc omnios.v1.DeliveryService.CreateShipment
     */
    createShipment: {
      name: "CreateShipment",
      I: CreateShipmentRequest,
      O: Shipment,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DeliveryService.TrackShipment
     */
    trackShipment: {
      name: "TrackShipment",
      I: TrackShipmentRequest,
      O: Shipment,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DeliveryService.CancelShipment
     */
    cancelShipment: {
      name: "CancelShipment",
      I: CancelShipmentRequest,
      O: Shipment,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DeliveryService.GetShipment
     */
    getShipment: {
      name: "GetShipment",
      I: GetShipmentRequest,
      O: Shipment,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DeliveryService.ListShipments
     */
    listShipments: {
      name: "ListShipments",
      I: ListShipmentsRequest,
      O: ListShipmentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Built-in zone/rate management
     *
     * @generated from rpc omnios.v1.DeliveryService.CreateDeliveryZone
     */
    createDeliveryZone: {
      name: "CreateDeliveryZone",
      I: CreateDeliveryZoneRequest,
      O: DeliveryZone,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DeliveryService.UpdateDeliveryZone
     */
    updateDeliveryZone: {
      name: "UpdateDeliveryZone",
      I: UpdateDeliveryZoneRequest,
      O: DeliveryZone,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DeliveryService.DeleteDeliveryZone
     */
    deleteDeliveryZone: {
      name: "DeleteDeliveryZone",
      I: DeleteDeliveryZoneRequest,
      O: DeliveryZone,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DeliveryService.ListDeliveryZones
     */
    listDeliveryZones: {
      name: "ListDeliveryZones",
      I: ListDeliveryZonesRequest,
      O: ListDeliveryZonesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DeliveryService.CreateDeliveryRate
     */
    createDeliveryRate: {
      name: "CreateDeliveryRate",
      I: CreateDeliveryRateRequest,
      O: DeliveryRate,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DeliveryService.UpdateDeliveryRate
     */
    updateDeliveryRate: {
      name: "UpdateDeliveryRate",
      I: UpdateDeliveryRateRequest,
      O: DeliveryRate,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DeliveryService.DeleteDeliveryRate
     */
    deleteDeliveryRate: {
      name: "DeleteDeliveryRate",
      I: DeleteDeliveryRateRequest,
      O: DeliveryRate,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DeliveryService.ListDeliveryRates
     */
    listDeliveryRates: {
      name: "ListDeliveryRates",
      I: ListDeliveryRatesRequest,
      O: ListDeliveryRatesResponse,
      kind: MethodKind.Unary,
    },
  }
};

